import React, { useState, useEffect, useRef } from 'react';
import styles from './RangeSlider.module.css';

const RangeSlider = ({
  min = 0,
  max = 100,
  step = 1,
  defaultLeftValue = 25,
  defaultRightValue = 75,
  onChange
}) => {
  const sliderRef = useRef(null);
  const [leftValue, setLeftValue] = useState(defaultLeftValue);
  const [rightValue, setRightValue] = useState(defaultRightValue);
  const [isDragging, setIsDragging] = useState(null);

  const getPercentage = (value) => {
    return ((value - min) / (max - min)) * 100;
  };

  const handleMouseDown = (e, handle) => {
    e.preventDefault();
    setIsDragging(handle);
  };

  const handleTouchStart = (e, handle) => {
    e.preventDefault();
    setIsDragging(handle);
  };

  const handleMouseUp = () => {
    setIsDragging(null);
  };

  const handleMove = (clientX) => {
    if (!isDragging || !sliderRef.current) return;

    const sliderRect = sliderRef.current.getBoundingClientRect();
    const percentage = ((clientX - sliderRect.left) / sliderRect.width) * 100;
    const newValue = Math.round((percentage * (max - min)) / 100 / step) * step + min;

    if (isDragging === 'left') {
      if (newValue < rightValue && newValue >= min) {
        setLeftValue(newValue);
        onChange?.({ left: newValue, right: rightValue });
      }
    } else {
      if (newValue > leftValue && newValue <= max) {
        setRightValue(newValue);
        onChange?.({ left: leftValue, right: newValue });
      }
    }
  };

  const handleMouseMove = (e) => {
    handleMove(e.clientX);
  };

  const handleTouchMove = (e) => {
    handleMove(e.touches[0].clientX);
  };

  useEffect(() => {
    if (isDragging) {
      const handleGlobalMouseMove = (e) => {
        handleMouseMove(e);
      };

      const handleGlobalTouchMove = (e) => {
        handleTouchMove(e);
      };

      window.addEventListener('mousemove', handleGlobalMouseMove);
      window.addEventListener('mouseup', handleMouseUp);
      window.addEventListener('touchmove', handleGlobalTouchMove);
      window.addEventListener('touchend', handleMouseUp);

      return () => {
        window.removeEventListener('mousemove', handleGlobalMouseMove);
        window.removeEventListener('mouseup', handleMouseUp);
        window.removeEventListener('touchmove', handleGlobalTouchMove);
        window.removeEventListener('touchend', handleMouseUp);
      };
    }
  }, [isDragging]);

  return (
    <div className={styles.sliderContainer}>
      <div
        ref={sliderRef}
        className={styles.sliderControl}
      >
        <div className={styles.track} />
        <div
          className={styles.range}
          style={{
            left: `${getPercentage(leftValue)}%`,
            width: `${getPercentage(rightValue) - getPercentage(leftValue)}%`,
          }}
        />
        <div
          className={styles.handle}
          draggable="false"
          style={{ left: `${getPercentage(leftValue)}%` }}
          onMouseDown={(e) => handleMouseDown(e, 'left')}
          onTouchStart={(e) => handleTouchStart(e, 'left')}
        />
        <div
          className={styles.handle}
          draggable="false"
          style={{ left: `${getPercentage(rightValue)}%` }}
          onMouseDown={(e) => handleMouseDown(e, 'right')}
          onTouchStart={(e) => handleTouchStart(e, 'right')}
        />
      </div>
    </div>
  );
};

export default RangeSlider;
